import apiAxios from 'helpers/apiAxios';

// App Settings → Reminders (admin): every scheduled reminder of the Portal
// (backend Reminders::Registry). One API for all of them, keyed by reminder key.
const BASE = '/reminders';

export const listReminders = () => apiAxios.get(BASE).then((r) => r.data);
export const getReminder = (key) => apiAxios.get(`${BASE}/${key}`).then((r) => r.data);
export const saveReminder = (key, settings) => apiAxios.put(`${BASE}/${key}`, { settings }).then((r) => r.data);
export const sendReminderTest = (key) => apiAxios.post(`${BASE}/${key}/test`).then((r) => r.data);
export const sendReminderNow = (key) => apiAxios.post(`${BASE}/${key}/send_now`).then((r) => r.data);
